<template>
  <div id="financial-education" class="header-gap bo">
    <div class="sub-banner">
      <div class="container">
        <h1 v-html="$t('financial-education.banner-title')"></h1>
        <p v-html="$t('financial-education.banner-desc')"></p>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="column">
          <h2>{{$t("financial-education.doo-academy")}}</h2>
          <p><i></i> {{$t("financial-education.doo-academy-desc")}}</p>
          <a href="https://www.dooacademy.com/" target="_blank" v-t="'business-overview.learn-more'"></a>
        </div>
        <div>
          <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/financialEducation_image1.png" />
        </div>
      </div>
    </div>
    <BOContactUs bocontent="financial-education"/>
  </div>
  <Modals />
</template>
  
<script setup>
  import "../less/style.css"
  import Modals from '@/components/Modals/ModalMain.vue'
  import BOContactUs from '@/components/BOContactUs.vue'

  import { useHead } from '@unhead/vue'
  import { useI18n } from 'vue-i18n'
  import { computed, onMounted } from 'vue'
  import { decodeHtml } from '@/utils'

  const { t } = useI18n()

  useHead({
    title: computed(() => decodeHtml(t('seo.financialeducation.title'))),
    meta: [
      { name: 'description', content: computed(() => t('seo.financialeducation.description')) },
      { name: 'keywords', content: computed(() => t('seo.financialeducation.keywords')) },
    ],
  })

  onMounted(() => {
    if (typeof document !== 'undefined')
      document.dispatchEvent(new Event('prerender-ready'))
  })

</script>

<style lang="less">
  @import '../less/mediaQuery.less';

  #financial-education {
    .sub-banner {
      background:url('https://cdn.dootech.io/doo/business_overview/banner_financialEducation.png') no-repeat center top;
      @media @mobile-screen {
        background:url('https://cdn.dootech.io/doo/business_overview/banner_financialEducation_mobile.png') no-repeat center top;
      }
      .container {
        @media only screen and (max-width:1500px) and (min-width:835px) {
          max-width: 40%;
          margin: 0;
        }
      }
    }
    @media only screen and (max-width:1400px) and (min-width:951px) {
      .container {
        padding:0 32px;
      }
    }
  }
</style>
